import React from 'react';
import Icon from '@components/@core/Icon';

const Initial = ({ name, background, upload, hidden = false }) => (
    <div className={hidden ? 'hidden ds-avatar-initial' : 'ds-avatar-initial'} style={{ backgroundColor: background }}>
        {upload && <Icon name="fas fa-file-upload" color="#376caf" />}
        {name}
    </div>
);

export default Initial;
